module.exports = __webpack_public_path__ + "static/media/IMG_0381_Reduced.27be053f.jpg";